module.exports = __webpack_public_path__ + "static/gallery14-9b2382f991d3332c17743ab36b9440cd.png";